"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feature2OpenPopupSelector = exports.feature2FlyToSelector = exports.definitionExpressionSelector = exports.allFeaturesSelector = exports.visibleFeaturesSelector = exports.updateWildfireFeature2OpenPopup = exports.updateWildfireFeature2FlyTo = exports.updateVisibleFeatures = exports.loadWildfires = exports.WildfireFeatureFields = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var WildfireFeatureFields;
(function (WildfireFeatureFields) {
    WildfireFeatureFields["OBJECTID"] = "OBJECTID";
    WildfireFeatureFields["IrwinID"] = "IrwinID";
    WildfireFeatureFields["GlobalID"] = "GlobalID";
    WildfireFeatureFields["UniqueFireIdentifier"] = "UniqueFireIdentifier";
    WildfireFeatureFields["IncidentName"] = "IncidentName";
    WildfireFeatureFields["IncidentTypeCategory"] = "IncidentTypeCategory";
    WildfireFeatureFields["DiscoveryAcres"] = "DiscoveryAcres";
    WildfireFeatureFields["DailyAcres"] = "DailyAcres";
    WildfireFeatureFields["CalculatedAcres"] = "CalculatedAcres";
    WildfireFeatureFields["FinalAcres"] = "FinalAcres";
    WildfireFeatureFields["PercentContained"] = "PercentContained";
    WildfireFeatureFields["FireDiscoveryDateTime"] = "FireDiscoveryDateTime";
    WildfireFeatureFields["POOCounty"] = "POOCounty";
    WildfireFeatureFields["POOState"] = "POOState";
    WildfireFeatureFields["FireCause"] = "FireCause";
})(WildfireFeatureFields = exports.WildfireFeatureFields || (exports.WildfireFeatureFields = {}));
;
;
;
;
;
var slice = toolkit_1.createSlice({
    name: 'wildfires',
    initialState: {
        byUniqueId: {},
        visibleFeatureUniqueIds: [],
        definitionExpression: 'PercentContained < 100',
        feature2FlyTo: null
    },
    reducers: {
        featuresLoaded: function (state, action) {
            var features = action.payload;
            features.forEach(function (feature) {
                var UniqueFireIdentifier = feature.attributes.UniqueFireIdentifier;
                state.byUniqueId[UniqueFireIdentifier] = feature;
            });
        },
        visibleFeaturesChanged: function (state, action) {
            var uniqueIds = action.payload;
            state.visibleFeatureUniqueIds = uniqueIds;
        },
        feature2FlyToChanged: function (state, action) {
            state.feature2FlyTo = action.payload;
        },
        feature2OpenPopupChanged: function (state, action) {
            state.feature2OpenPopup = action.payload;
        },
    }
});
var reducer = slice.reducer;
var _a = slice.actions, featuresLoaded = _a.featuresLoaded, visibleFeaturesChanged = _a.visibleFeaturesChanged, feature2FlyToChanged = _a.feature2FlyToChanged, feature2OpenPopupChanged = _a.feature2OpenPopupChanged;
var delayforOpenPopup;
exports.loadWildfires = function (features) { return function (dispatch, getState) {
    if (features) {
        dispatch(featuresLoaded(features));
    }
}; };
exports.updateVisibleFeatures = function (uniqueIds) { return function (dispatch, getState) {
    dispatch(visibleFeaturesChanged(uniqueIds));
}; };
exports.updateWildfireFeature2FlyTo = function (feature) { return function (dispatch, getState) {
    dispatch(feature2FlyToChanged(feature));
}; };
exports.updateWildfireFeature2OpenPopup = function (feature) { return function (dispatch, getState) {
    clearTimeout(delayforOpenPopup);
    if (!feature) {
        dispatch(feature2OpenPopupChanged(feature));
    }
    else {
        delayforOpenPopup = setTimeout(function () {
            dispatch(feature2OpenPopupChanged(feature));
        }, 500);
    }
}; };
exports.visibleFeaturesSelector = toolkit_1.createSelector(function (state) { return state.wildfires.byUniqueId; }, function (state) { return state.wildfires.visibleFeatureUniqueIds; }, function (byUniqueId, visibleFeatureUniqueIds) {
    return visibleFeatureUniqueIds.map(function (id) {
        return byUniqueId[id];
    });
});
exports.allFeaturesSelector = toolkit_1.createSelector(function (state) { return state.wildfires.byUniqueId; }, function (byUniqueId) {
    var features = Object.keys(byUniqueId).map(function (id) {
        return byUniqueId[id];
    });
    return features;
});
exports.definitionExpressionSelector = toolkit_1.createSelector(function (state) { return state.wildfires.definitionExpression; }, function (definitionExpression) { return definitionExpression; });
exports.feature2FlyToSelector = toolkit_1.createSelector(function (state) { return state.wildfires.feature2FlyTo; }, function (feature2FlyTo) { return feature2FlyTo; });
exports.feature2OpenPopupSelector = toolkit_1.createSelector(function (state) { return state.wildfires.feature2OpenPopup; }, function (feature2OpenPopup) { return feature2OpenPopup; });
exports.default = reducer;
